import { APICore } from "./apiCore";

const api = new APICore();

function getOrdersApi(filter: string, status: string) {
  const baseUrl = "/orders";
  return api.get(`${baseUrl}/${filter}/${status}`, {});
}

function getOrdersRevenueApi(type: string, from: string, to: string) {
  const baseUrl = "/orders_revenue";
  if (from == "" || to == "") {
    return api.get(`${baseUrl}/${type}`, {});
  } else {
    return api.get(`${baseUrl}/${type}/${from}/${to}`, {});
  }
}

function getOrdersRevenueUsdApi() {
  const baseUrl = "/orders_revenue_old";
  return api.get(`${baseUrl}`, {});
}

export { getOrdersApi, getOrdersRevenueApi, getOrdersRevenueUsdApi };
